/*
 * @Author: w9013327 v-maijiahua@oppo.com
 * @Date: 2023-01-16 15:15:58
 * @LastEditors: w9013327 v-maijiahua@oppo.com
 * @LastEditTime: 2023-12-13 18:18:10
 * @FilePath: \sns-user-frontend\src\jsBridgeApi\oppo.js
 * @Description: 
 */
import { setCookie } from '@/utils'

export default {
  // 跳转动作
  async openBrowser (link) {
    await window.HeytapJsApi.invoke({
			name: 'launchActivity',
			module: "vip",
			data: {
				linkInfo: {
          linkDetail: [{
            linkType: 'BROWSER',
            linkUrl: link || location.href
          }]
        }
			}
		})
  },
  // 隐藏客户端头部
  hideClientTitle () {
		window.HeytapJsApi.invoke({
			name: 'setClientTitle',
			module: "vip",
			data: {
				toolbarType: 1
			}
		})
	},
  // 关闭客户端loading
	closeLoading () {
		window.HeytapJsApi.invoke({
			name: "onDomLoadFinish",
			module: "vip",
		})
	},
  // 开启新容器
	openNewWebview (url) {
		if (location.href.indexOf('credit') >= 0) {
			window.location.href = `uc://platform.usercenter.com/webext?url=${encodeURIComponent(url)}`
			return 
		}
    if (window.HeytapNativeApi.invoke) {
      window.HeytapJsApi.invoke({
        name: "open",
        module: "common",
        data: {
          url,
          style: "vip",
        }
      })
    }  else {
      // location.href = url
      window.open(url)
    }
	},
  // 获取手机型号
  async getDeviceName () {
    let xSafety = {}
    const { data } = await window.HeytapJsApi.invoke({
      name: "getHeaderJson",
      module: "vip",
    })
    try {
      xSafety = JSON.parse(data['X-Safety'])
    } catch {}
    return xSafety.marketName
  },
  // 调起客户端给登录页面
	loginPage () {
    window.HeytapJsApi.invoke({
      name: "showLogin",
      module: "vip"
    })
	},
	// 获取登录态
	async getToken () {
    try {
      let res = await window.HeytapJsApi.invoke({
        name: "getToken",
        data: {},
        module: "vip",
      })
      if (res?.code === 0 && res?.data.token) {
        setCookie("token", res.data.token);
      } else {
        console.error('no token')
      }
    } catch {
      console.error('get app token error', e)
      return false
    }
	},
	// 返回上一级/销毁当前容器
	goBack () {
    window.HeytapJsApi.invoke({
      name: "goBack",
      module: "vip",
    })
    
	},
	/**
	 * @param {
	 *      title: "分享标题", // 分享标题
	 *      desc: "分享内容", // 分享详细描述
	 *      link: "testhttp://www.baidu.com", //链接||图片链接
	 *      imgUrl:
	 *      "https://assorted.downloads.oppo.com/static/assets/products/encoM1/		images/1080/m1_3-947cf2d608f8b6b5fddbd07939fc7c18.jpg", // 分享图片
	 *      type: "link", // 分享资源的类型 可选link  music   video   image，当非link时，dataUrl字段不能为空,image时是图文分享
	 *      dataUrl: "https://assorted.downloads.oppo.com/static/assets/products/encoM1/images/1080/m1_1-977729f43e36d53a5912d792d17a7f5d.jpg"
	 * }
   * 图文分享时link必须为图片链接，type必须为image
	 */
	share (data) {
    window.HeytapJsApi.invoke({
      name: "showShareMenu",
      module: "common",
      data
    })
	},
	// 获取设备信息
	async getDeviceInfo () {
		const data = await window.HeytapJsApi.invoke({
      name: 'getDeviceInfo',
      module: "common",
      data: {},
    })
    return data
	},
	// 获取客户端消息
	async getClientContext () {
    const data = await window.HeytapJsApi.invoke({
      name: "getClientContext",
      module: "vip",
      data: {},
    })
		return data
	},
  // 获取版本信息
	async getSdkVersion () {
    const data = await window.HeytapJsApi.invoke({
      name: "common.sdk_version",
    })
    return data
	},
	// 获取客户端消息
	async getAppInfo () {
    const data = await window.HeytapJsApi.invoke({
      name: "common.app_info",
    })
    return data
	},
	async getNetworkState() {
    const data = await window.HeytapJsApi.invoke({
      name: "common.network_state",
    })
    return data
	},
	// 监听返回页面回调
	onResume(callback) {
		window.HeytapJsApi.registeAction("onResume", () => {
			typeof callback === "function" && callback();
		});
		// window.HeytapJsApi.registeAction("prevExit", () => {
		// 	typeof callback === "function" && callback();
		// });
	},

  // 询问权限获取
  onManageSystemPermission() {
    window.HeytapJsApi.invoke({
      name: "managePermission",
      module: "vip",
      data: {
        type: 'requestPermission',
        permissions: ['android.permission.CAMERA']
      }
    })
  }
}